import { Recipe } from './recipe';

export class RecipeWrapper {

    public type: string;
    public recipe: Recipe;
    public deleted: Boolean;
}